import { DataLoaderParams } from '@/types/DataLoaderParams';
import { fetchSellersIfNeeded } from '@/redux/modules/seller';

export default ({ match, store }: DataLoaderParams) => {
    const { params } = match;
    const { dispatch } = store;
    const sellerId = Number(params.sellerId);

    return dispatch(fetchSellersIfNeeded([sellerId]));
};
